import QRCodeScannerDialog from './QRCodeScannerDialog';
export default QRCodeScannerDialog;